import {
    AfterViewInit,
    Component,
    ElementRef,
    Input,
    ViewChild,
} from '@angular/core';
import { Router } from '@angular/router';

@Component({
    selector: 'app-inner-content',
    templateUrl: './inner-content.component.html',
    styleUrls: ['./inner-content.component.scss'],
    standalone: true,
})
export class InnerContentComponent implements AfterViewInit {
    @ViewChild('content') contentEl: ElementRef | null = null;
    @Input()
    get content() {
        return this._content;
    }
    set content(content: string) {
        if (this.contentEl) {
            this.contentEl.nativeElement.innerHTML = content;
        }
        this._content = content;
    }
    private _content: string = '';

    constructor(private readonly router: Router) {}

    ngAfterViewInit(): void {
        if (this.contentEl) {
            this.contentEl.nativeElement.innerHTML = this._content;
        }
        this.scrollToSection();
    }

    scrollToSection(): void {
        if (this.router.url.split('#')[1]) {
            const findSection = document.querySelector(
                '#' + this.router.url.split('#')[1],
            );
            findSection?.scrollIntoView();
        }
    }

    internalLinkRouting(e: any): void {
        e.preventDefault();
        const href = e.target.closest('a').getAttribute('href');
        const bits = href.split('#');
        const path = bits[0];
        const frag = bits.length > 1 ? bits[1] : false;
        this.router.navigate([path], { fragment: frag });
    }
}
